/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Classification_Agent_NativeInputs */

const en_directory_agent_readiness_classification_agent_native = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_NativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent native`)
};

const zh_directory_agent_readiness_classification_agent_native = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_NativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 原生`)
};

/**
* | output |
* | --- |
* | "Agent native" |
*
* @param {Directory_Agent_Readiness_Classification_Agent_NativeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_classification_agent_native = /** @type {((inputs?: Directory_Agent_Readiness_Classification_Agent_NativeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Classification_Agent_NativeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_classification_agent_native(inputs)
	return zh_directory_agent_readiness_classification_agent_native(inputs)
});
export { directory_agent_readiness_classification_agent_native as "directory.agent_readiness.classification.agent_native" }